import { render, staticRenderFns } from "./ProductViewPurchasesOrders.vue?vue&type=template&id=a04dab72"
import script from "./ProductViewPurchasesOrders.vue?vue&type=script&lang=js"
export * from "./ProductViewPurchasesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports